import { Injectable } from '@angular/core';
import { IDataTableService } from '../shared-module/common/interfaces/IDataTableService.interface';
import { DataTableFilter } from '../shared-module/common/models/DataTableFilter.model';
import { Observable, from } from 'rxjs';
import { ExampleTypeRow, ExampleDataTable, ExampleTranslationField } from './playbook.model';
import { ITranslationFieldService } from '../shared-module/common/interfaces/ITranslationFieldService.interface';

@Injectable()
export class PlaybookService implements IDataTableService<ExampleTypeRow>, ITranslationFieldService {

    public productId: number;
    getRows(filter: DataTableFilter): Observable<ExampleDataTable> {
        let dataTable = new ExampleDataTable();
        if (!filter) {
            return from([dataTable]);
        }

        if (filter.quickFilter) {
            this.filterDataTable(dataTable, 'name', filter.quickFilter);
        }
        else if (filter.filters) {
            filter.filters.forEach(columnFilter => {
                this.filterDataTable(dataTable, columnFilter.name, columnFilter.value);
            }); 
        }

        return from([dataTable]);
    }

    private filterDataTable(dataTable: ExampleDataTable, filterName: string, value: string) {
        dataTable.pagedRecords = dataTable.pagedRecords.filter(record => !value || record[filterName].toLowerCase().includes(value.toLowerCase()));
        dataTable.totalNumberOfRecords = dataTable.pagedRecords.length;
    }

    saveTranslations(translationField: ExampleTranslationField) {

    }

}

